import React, { useState } from "react";
import Sidebar from "../../Sidebar"; 
import "./MemberDirectory.css";

const membersData = [
  {
    id: 1,
    initials: "RK",
    name: "Rajesh Kumar",
    manager: "Ganesh Shinde",
    localName: "राजु पाटील",
    total: 5,
    active: 0,
    f2f: 0,
  },
  {
    id: 2,
    initials: "PS",
    name: "Priya Sharma",
    manager: "Ganesh Shinde",
    localName: "प्रिया शर्मा",
    total: 12,
    active: 1,
    f2f: 2,
  },
  {
    id: 3,
    initials: "VD",
    name: "Vikram Desai",
    manager: "Ganesh Shinde",
    localName: "विक्रम गावकर",
    total: 9,
    active: 1,
    f2f: 4,
  },
  {
    id: 4,
    initials: "SR",
    name: "Sanjay Rao",
    manager: "Ganesh Shinde",
    localName: "निशा देसाई",
    total: 12,
    active: 2,
    f2f: 1,
  },
  {
    id: 5,
    initials: "AK",
    name: "Amit Kumar",
    manager: "Ganesh Shinde",
    localName: "अमित कुमार",
    total: 8,
    active: 1,
    f2f: 3,
  },
  {
    id: 6,
    initials: "SN",
    name: "Sneha Nair",
    manager: "Ganesh Shinde",
    localName: "स्नेहा नायर",
    total: 15,
    active: 3,
    f2f: 5,
  },
];

const MemberDirectory = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedManager, setSelectedManager] = useState("Ganesh Shinde");
  const [selectedTeam, setSelectedTeam] = useState("All Team Leads");
  const [searchTerm, setSearchTerm] = useState("");

  // Get color for avatar based on name
  const getAvatarColor = (name: string): string => {
    // const colors = [
    //   '#4A90D9', '#27AE60', '#F39C12', '#8E44AD',
    //   '#1ABC9C', '#E67E22', '#E74C3C', '#3498DB',
    //   '#2ECC71', '#9B59B6', '#F1C40F', '#1ABC9C'
    // ];
    const colors = [
      '#5C5DE6', '#5C5DE6', '#5C5DE6', '#5C5DE6',
      '#5C5DE6', '#5C5DE6', '#5C5DE6', '#5C5DE6',
      '#5C5DE6', '#5C5DE6', '#5C5DE6', '#5C5DE6'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  // Filter members based on search
  const filteredMembers = membersData.filter(member =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.localName.includes(searchTerm) ||
    member.manager.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="member-directory-wrapper">
      <Sidebar  />
      <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        <div className="member-directory">
          <div className="directory-header">
            <div className="header-left">
              <h1>Member Directory</h1>
              <p className="sub-title">All members can submit leads to multiple cities</p>
            </div>
            
            <div className="search-container">
              <input
                type="text"
                placeholder="Search members..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          <div className="filters">
            <div className="filter-group">
              {/* <label>Manager</label> */}
              <select
                value={selectedManager}
                onChange={(e) => setSelectedManager(e.target.value)}
              >
                <option>Ganesh Shinde</option>
                <option>Rajesh Kumar</option>
                <option>Priya Sharma</option>
                <option>Vikram Desai</option>
              </select>
            </div>

            <div className="filter-group">
              {/* <label>Team</label> */}
              <select
                value={selectedTeam}
                onChange={(e) => setSelectedTeam(e.target.value)}
              >
                <option>All Team Leads</option>
                <option>Team Lead 1</option>
                <option>Team Lead 2</option>
                <option>Team Lead 3</option>
              </select>
            </div>

        
          </div>

          <div className="member-grid">
            {filteredMembers.map((member) => (
              <div className="member-card" key={member.id}>
                <div className="member-header">
                  <div className="avatar" style={{ backgroundColor: getAvatarColor(member.name) }}>
                    {member.initials}
                  </div>

                  <div className="member-info">
                    <h3>{member.name}</h3>
                    <p className="manager-name">{member.manager}</p>
                    <span className="local-name">{member.localName}</span>
                  </div>
                </div>
                <div className="stats-row">
                  <div className="stat-box">
                    <span>Total</span>
                    <strong>{member.total}</strong>
                  </div>
                  <div className="stat-box">
                    <span>Active</span>
                    <strong className="active">{member.active}</strong>
                  </div>
                  <div className="stat-box">
                    <span>F2F</span>
                    <strong className="f2f">{member.f2f}</strong>
                  </div>
                </div>
                <button className="view-btn">View Details</button>
              </div>
            ))}
          </div>
          {filteredMembers.length === 0 && (
            <div className="empty-state">
              <span className="empty-icon">🔍</span>
              <h3>No members found</h3>
              <p>Try adjusting your search criteria</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberDirectory;